<template>
  <v-dialog
    v-model="show"
    max-width="1200"
    :persistent="topUpLoading"
    :fullscreen="this.$vuetify.breakpoint.xs"
  >
    <v-card>
      <v-row align="center" class="pa-5 ma-0">
        <v-col>
          <div class="text-left display-1">
            Kaart opwaarderen
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="text-right">
          <v-btn icon @click="show = false" :disabled="topUpLoading">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>

      <v-card flat>
        <div class="pa-5">
          <v-row>
            <v-col md="6" cols="12">
              <v-form>
                <div class="text-left headline mb-5">
                  Selecteer hieronder het gewenste bedrag
                </div>
                <v-item-group mandatory class="mb-5" v-model="selected">
                  <v-row>
                    <v-col
                      v-for="n in this.$organization.prepaid_bonuses"
                      :key="n.id"
                    >
                      <v-item v-slot:default="{ active, toggle }">
                        <v-btn :text="!active" @click="toggle" color="primary">
                          <div class="display-1 font-weight-medium">
                            {{ (n.amount / 100) | currency }}
                          </div>
                        </v-btn>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-item-group>
                <v-scale-transition>
                  <div
                    v-if="
                      this.$organization.prepaid_bonuses[selected]['bonus'] >
                        0 && show
                    "
                  >
                    <v-divider class="my-4"></v-divider>
                    <div>
                      Gratis bonus:
                      {{
                        $currency(
                          this.$organization.prepaid_bonuses[selected][
                            "bonus"
                          ] / 100
                        )
                      }}
                    </div>
                    <v-divider class="my-4"></v-divider>
                  </div>
                </v-scale-transition>
                <v-checkbox
                  v-model="acceptConditions"
                  color="primary"
                  label="Ik accepteer de algemene voorwaarden"
                  class="mt-0"
                >
                  <template slot="append">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon @click="gotoConditions" v-on="on"
                          >mdi-script-text-outline
                        </v-icon>
                      </template>
                      <span>Open algemene voorwaarden</span>
                    </v-tooltip>
                  </template>
                </v-checkbox>
              </v-form>
            </v-col>
            <v-col class="text-center hidden-sm-and-down" align-self="center">
              <div class="display-1">Uw huidige slado</div>
              <div class="primary--text display-3 font-weight-medium">
                {{
                  (this.$store.getters["user/user"].prepaid / 100) | currency
                }}
              </div>
            </v-col>
          </v-row>
        </div>

        <div class="pa-5">
          <v-btn
            color="primary"
            @click="pay"
            class="no-text-transform display-1"
            :disabled="selected === undefined || !acceptConditions"
            :loading="topUpLoading"
            >Afrekenen
          </v-btn>
        </div>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "balanceTopUpDialog",
  props: ["value"],

  data() {
    return {
      selected: 0,
      acceptConditions: false,
      topUpLoading: false
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    pay() {
      this.topUpLoading = true;
      this.$store.dispatch(
        "topup/topUp",
        this.$organization.prepaid_bonuses[this.selected]
      );
    },
    gotoConditions() {
      this.$store.commit("viewstate/triggerConditionDialog");
    }
  }
};
</script>

<style scoped></style>
